import serializeForm from './utils/consultation/serialize-form';
import { validate } from './utils/validation';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { slideToggle } from './startup/slide';
import { debounce } from './utils/utils';
dayjs.extend(customParseFormat);
const tariffServiceUrl = window.backendApiUrl + '/tariff';

/**
 *
 * @param {string} dateOfBirth
 * @returns
 */
const getAgeFromDoB = dateOfBirth => {
  return dayjs().diff(dayjs(dateOfBirth, 'YYYY-MM-DD'), 'year');
};

document.querySelectorAll('.comprehensiveQqc-block').forEach(block => {
  //containers
  const form = block.querySelector('.form');
  const slideWrapper = form.querySelector('.qqc-slide-wrapper');
  const basicSlide = form.querySelector('.basic');
  const optionsSlide = form.querySelector('.extended');
  const optionsContentMobile = form.querySelector('.content-toggle');

  //buttons
  const optionsToggle = form.querySelector('.customize-tariff-btn');
  const optionsReturnButton = form.querySelector('.back-btn');
  const optionsToggleMobile = form.querySelector('.head-toggle');
  const submitButton = form.querySelector('.submitter');

  //basic inputs
  const dobInput = form.querySelector('.dob-input');
  const ingressDateSelect = form.querySelector('.start-select');
  const employmentSelect = form.querySelector('.status-select');

  //options inputs
  const deductibleSelect = form.querySelector('.deductible-select');
  const highDeductibleOption = deductibleSelect.querySelector('option[value="25"]');
  const allowanceGroup = form.querySelector('.dsa-group');
  const allowanceValueSelect = form.querySelector('.dsa-payout-select');
  const allowanceFromSelect = form.querySelector('.dsa-after-days-select');

  const protectionGroup = form.querySelector('.protection-group');
  const protectionValueSelect = form.querySelector('.protection-value-select');
  const protectionFromSelect = form.querySelector('.protection-from-select');

  let optionsShown = false;
  let formdataCache = {};

  const euroValueToString = value => {
    return en ? `€ ${value / 100}` : `${value / 100} €`;
  };

  /**
   * updates the options of a select with an array of new options
   * @param {HTMLElement} select
   * @param {Array<{value: string, label:string}>} options Array of objects with data-object for each entry
   * @param {boolean} nullOption should the first option be kept? (as null value option)
   */
  const addOptions = (select, options, nullOption = false) => {
    const optionsFragment = document.createDocumentFragment();
    options.forEach((option, index) => {
      const optionElement = document.createElement('option');
      optionElement.value = option.value;
      optionElement.selected = nullOption === false && index === 0;
      optionElement.innerText = option.label;
      optionsFragment.appendChild(optionElement);
    });
    if (nullOption) {
      const fistOption = select.querySelector('option');
      optionsFragment.prepend(fistOption);
    }
    select.innerHTML = '';
    select.append(optionsFragment);
  };

  const protectionFromSelectWrapper = protectionFromSelect.closest('.otto-form-element');
  const updateBekDisabled = () => {
    const emptyValue = protectionValueSelect.value === 'none';
    protectionFromSelect.disabled = emptyValue;
    protectionFromSelectWrapper.classList.toggle('disabled', emptyValue);
  };
  const allowanceFromSelectWrapper = allowanceFromSelect.closest('.otto-form-element');
  const updateDsaDisabled = () => {
    const emptyValue = allowanceValueSelect.value === 'none';
    allowanceFromSelect.disabled = emptyValue;
    allowanceFromSelectWrapper.classList.toggle('disabled', emptyValue);
  };

  /**
   * updates all selects regarding the dsa
   * @param {"employed" | "self-employed" | "student" } employment
   * @param {string} ingressDate date-string for te ingress date
   * @returns
   */
  const updateDsa = async (employment, ingressDate, dateOfBirth) => {
    const age = getAgeFromDoB(dateOfBirth);
    if (employment === 'student' || age < 18 || age > 69) {
      allowanceGroup.style.display = 'none';
      return;
    }
    allowanceGroup.style = '';

    const dsaData = await fetch(`${tariffServiceUrl}/otto/dsa/range?occupational_status=${employment}&number_of_employees=0&profession_id=999&ingress_date=${ingressDate}&salary=69999`).then(
      response => response.json()
    );

    // update waiting days
    addOptions(
      allowanceFromSelect,
      dsaData.waiting_days.map(day => ({
        value: day,
        label: en ? `${day}. day` : `${day}. Tag`
      }))
    );
    //update dsa possible values
    const options = [];
    for (let value = dsaData.min; value <= dsaData.max; value += dsaData.step) {
      options.push({
        value: value / 100,
        label: euroValueToString(value)
      });
    }
    addOptions(allowanceValueSelect, options, true);
    updateDsaDisabled();
  };

  /**
   * updates all selects regarding the bek
   * @param {"employed" | "self-employed" | "student" } employment
   * @param {string} dateOfBirth
   * @param {"10" | "25" | "50"} deductible
   * @param {string} ingressDate date-string for te ingress date
   * @returns
   */
  const updateBek = async (employment, dateOfBirth, deductible, ingressDate) => {
    const age = getAgeFromDoB(dateOfBirth);
    if (employment === 'student' || age < 21 || age > 55) {
      protectionGroup.style.display = 'none';
      return;
    }
    protectionGroup.style = '';

    const bekdata = await fetch(
      `${tariffServiceUrl}/otto/bek/range?occupational_status=${employment}&date_of_birth=${dateOfBirth}&tariff_name=business2019twin&tariff_excess=${deductible}&ingress_date=${ingressDate}`
    ).then(response => response.json());

    const options = [];
    for (let value = bekdata.min; value <= bekdata.max; value += bekdata.step) {
      options.push({
        value: value / 100,
        label: euroValueToString(value)
      });
    }
    addOptions(protectionValueSelect, options, true);
    updateBekDisabled();
  };

  const studentLabel = highDeductibleOption.dataset.studentLabel;
  const defaultLabel = highDeductibleOption.dataset.defaultLabel;
  /**
   * updates select regarding the dedutible and returns current detuctible value after update
   * @returns deductible value
   */
  const updateDetuctible = () => {
    const employment = serializeForm(form).employment;
    if (employment === 'student') {
      highDeductibleOption.value = '50';
      highDeductibleOption.innerHTML = studentLabel;
    } else {
      highDeductibleOption.value = '25';
      highDeductibleOption.innerHTML = defaultLabel;
    }
    return deductibleSelect.value;
  };

  /**
   * compares the current form values with it's last state and updates the inputs accordingly
   * @returns current for,dataCache
   */
  const updateOptions = async (formDataCurrent = serializeForm(form)) => {
    //update all the form elements with new values if needed
    if (formDataCurrent.employment !== formdataCache.employment) {
      formDataCurrent.deductible = updateDetuctible();
    }
    const updatePromises = [];
    if (['employment', 'date_of_birth', 'deductible', 'ingress_date'].some(key => formDataCurrent[key] !== formdataCache[key])) {
      updatePromises.push(updateBek(formDataCurrent.employment, formDataCurrent.date_of_birth, formDataCurrent.deductible, formDataCurrent.ingress_date));
    }
    if (['employment', 'ingress_date', 'date_of_birth'].some(key => formDataCurrent[key] !== formdataCache[key])) {
      updatePromises.push(updateDsa(formDataCurrent.employment, formDataCurrent.ingress_date, formDataCurrent.date_of_birth));
    }
    await Promise.all(updatePromises);

    // update the data-cache with the new values
    formdataCache = serializeForm(form);
    return formdataCache;
  };

  // dynamically sets the ingress_date options to be the first day of the next 6 months
  const ingressOptions = [];
  const startDate = dayjs().date(1);
  for (let i = 1; i < 6; i++) {
    const date = startDate.add(i, 'Month');
    ingressOptions.push({
      value: date.format('YYYY-MM-DD'),
      label: date.format('DD.MM.YYYY')
    });
  }
  addOptions(ingressDateSelect, ingressOptions);

  [employmentSelect, ingressDateSelect, dobInput, deductibleSelect].forEach(input => {
    input.addEventListener('input', () => {
      const formDataCurrent = serializeForm(form);
      dobInput.dataset.bouncerMaxAge = formDataCurrent.employment === 'student' ? '37' : '101';
      if (validate.validate(dobInput)) {
        return;
      }
      updateOptions(formDataCurrent);
    });
  });

  protectionValueSelect.addEventListener('change', updateBekDisabled);

  allowanceValueSelect.addEventListener('change', updateDsaDisabled);

  // event listener for options toggle on desktop
  const boxHeight = () => {
    if (window.matchMedia('(min-width: 992px)').matches) {
      if (basicSlide.classList.contains('shown')) {
        const basicSlideHeight = basicSlide.offsetHeight;
        slideWrapper.style.height = basicSlideHeight + 'px';
      } else {
        const optionsSlideHeight = optionsSlide.offsetHeight;
        slideWrapper.style.height = optionsSlideHeight + 'px';
      }
    } else {
      slideWrapper.style = '';
    }
  };
  boxHeight();
  window.addEventListener('resize', debounce(boxHeight, 300));

  optionsToggle.addEventListener('click', async ev => {
    ev.preventDefault();
    if (validate.validate(dobInput)) {
      return;
    }
    await updateOptions();
    optionsShown = !optionsShown;
    basicSlide.classList.toggle('shown', !optionsShown);
    optionsSlide.classList.toggle('shown', optionsShown);
    boxHeight();
  });

  optionsReturnButton.addEventListener('click', ev => {
    optionsShown = false;
    ev.preventDefault();
    basicSlide.classList.toggle('shown', !optionsShown);
    optionsSlide.classList.toggle('shown', optionsShown);
    boxHeight();
  });

  // event listener for options toggle on mobile
  optionsToggleMobile.addEventListener('click', async ev => {
    ev.preventDefault();
    if (!optionsShown && validate.validate(dobInput)) {
      return;
    }
    await updateOptions();
    optionsShown = !optionsShown;
    slideToggle(optionsContentMobile, undefined, 300);
    optionsSlide.classList.toggle('active', optionsShown);
  });

  submitButton.addEventListener('click', ev => {
    ev.preventDefault();
    if (validate.validate(dobInput)) {
      return;
    }
    //assemble payload
    const formData = serializeForm(form);
    const holder = {
      occupational_status: formData.employment,
      signup_type: 'comprehensive',
      tariff: formData.employment === 'student' ? 'economy' : 'business2019twin',
      ingress_date: formData.ingress_date,
      date_of_birth: formData.date_of_birth,
      tariff_excess: parseInt(formData.deductible)
    };

    //optional payloads
    if (holder.occupational_status === 'employed') {
      holder.income = 69999;
    } else if (holder.occupational_status === 'self-employed') {
      holder.employees = 0;
    }
    if (holder.occupational_status !== 'student' && formData.dsa_requested_payout !== 'none') {
      holder.dsa_after_days = parseInt(formData.dsa_after_days);
      holder.dsa_requested_payout = parseInt(formData.dsa_requested_payout);
    }
    if (holder.occupational_status !== 'student' && formData.contribution_relief !== 'none') {
      holder.contribution_relief = parseInt(formData.contribution_relief);
      holder.contribution_relief_from_age = parseInt(formData.contribution_relief_from_age);
    }
    const payload = {
      holder
    };

    //set payload to localstorage and navigate
    localStorage.setItem('da-data-transfer', JSON.stringify(payload));
    document.location = '/online-beitragsrechner/dein-angebot/ergebnis?origin=comprehensive';
  });
});
